export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/6ed60b91eef8-tooliconcalculator.jpg',
  },
  title: "What's the total value of out-of-pocket expenses you're claiming for?",
}
